import React from 'react';
import styled from '@emotion/styled';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import CookieDeclaration from '../../presentation/features/settings/CookieDeclaration/CookieDeclaration';

const DataProtectionContainer = styled.div`
  background-color: #f4f7fb;
  border-radius: 8px;
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
`;

const Link = styled.a`
  color: #333;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

const Language = styled.span`
  display: block;
  color: #666;
  font-size: 14px;
`;

const documents = [
  {
    name: 'DATENSCHUTZERKLÄRUNG',
    lang: 'Deutsch',
    filename: 'GDB-Privacy-Policy-DE-DE.pdf',
  },
  {
    name: 'PRIVACY POLICY',
    lang: 'English',
    filename: 'GDB-Privacy-Policy-EN-GB.pdf',
  },
  {
    name: 'PRIVATLIVSPOLITIK',
    lang: 'Dansk',
    filename: 'GDB-Privacy-Policy-DA-DK.pdf',
  },
  {
    name: 'SEKRETESSPOLICY',
    lang: 'Svenska',
    filename: 'GDB-Privacy-Policy-SV-SE.pdf',
  },
  {
    name: 'TIETOSUOJAKÄYTÄNTÖ',
    lang: 'Suomalainen',
    filename: 'GDB-Privacy-Policy-FI-FI.pdf',
  },
  {
    name: 'PRIVATUMO POLITIKA',
    lang: 'Lietuvių',
    filename: 'GDB-Privacy-Policy-LT-LT.pdf',
  },
  {
    name: 'OŚWIADCZENIE O OCHRONIE DANYCH',
    lang: 'Polski',
    filename: 'GDB-Privacy-Policy-PL-PL.pdf',
  },
  {
    name: 'VYHLÁSENIE O OCHRANE OSOBNÝCH ÚDAJOV',
    lang: 'Slovenská',
    filename: 'GDB-Privacy-Policy-SK-SK.pdf',
  },
];

const baseUrl =
  'https://stcropconnectdevweu.blob.core.windows.net/legal-texts/';

const DataProtection: React.FC = () => {
  const { t } = useI18n();

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.dataprotection_title)} />
      <DataProtectionContainer>
        <List>
          {documents.map((doc, index) => (
            <ListItem key={index}>
              <Link
                href={`${baseUrl}${doc.filename}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {doc.name}
              </Link>
              <Language>{doc.lang} (PDF)</Language>
            </ListItem>
          ))}
        </List>
        <PageHeader title={t(TranslationKeys.cookie_declaration)} />
      </DataProtectionContainer>
      <CookieDeclaration />
    </MainContainer>
  );
};

export default DataProtection;
